<template>
  <div class="wrapper">
    <!-- v-loading.fullscreen="loading" -->
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamelist' }">{{ "竞技赛事" }}</router-link>
          <span>></span>
          <span>{{ "赛事详情" }}</span>
        </div>
      </div>
    </div>
    <div class="main bgw" style="background-color: rgba(250, 250, 250, 1)" v-loading="loading">
      <!-- v-loading="loadingShow" -->
      <div class="shop-container">
        <div class="t" style="padding: 20px; margin-bottom: 20px; background-color: #ffffff">
          <div class="tl">
            <div class="tl-img-box">
              <img :src="currentImg" alt="" />
              <!-- <vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify> -->
            </div>
            <!-- <div class="tl-tabs">
              <div class="img-list-box">
                <ul class="img-tabs" :style="{ width: ulWidth, left: ulLeft + 'px' }">
                  <li v-for="(img, index) in productImgList" :key="index" @click="changeShowImg(img)">
                    <img v-lazy="img" alt :key="img" />
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
          <div class="tr">
            <div class="tr-title">{{ gameInfo.title }}</div>

            <div class="tr-price tr-group">
              <div class="tr-title-left">{{ "报名费用：" }}</div>
              <div class="tr-right">
                <span class="now-price">
                  <i>￥</i>
                  <span class="price-num">{{ gameInfo.cost }}</span>
                </span>
              </div>
            </div>
            <div class="tr-group">
              <div class="tr-title-left">{{ "报名时间:" }}</div>
              <div class="tr-right">
                <span class="text">{{ gameInfo.stime + "至" + gameInfo.etime }}</span>
              </div>
            </div>
            <div class="tr-group">
              <div class="tr-title-left">{{ "比赛时间:" }}</div>
              <div class="tr-right">
                <span class="text">{{ gameInfo.gamestime2 + "至" + gameInfo.gameetime2 }}</span>
              </div>
            </div>
            <div class="tr-group">
              <div class="tr-title-left">{{ "比赛地址:" }}</div>
              <div class="tr-right">
                <span class="text">{{ gameInfo.address }}</span>
              </div>
            </div>
            <div class="tr-group" v-if="gameInfo && gameInfo.bow && gameInfo.bow.length > 0">
              <div class="tr-title-left">{{ "比赛弓种:" }}</div>
              <div class="tr-right">
                <!-- <span class="cx-item" v-for="(item,index) in gameInfo.bow" :key="index">{{item.name}}</span> -->
                <div
                  class="color"
                  v-for="(item, index) in gameInfo.bow"
                  :key="index"
                  :class="{ active: item.bow == form.bow }"
                  @click="(form.bow = item.bow), (choosePerson = false)"
                >
                  <a href="javascript:;">{{ item.name }}</a>
                </div>
              </div>
            </div>
            <div class="tr-group" v-if="gameInfo.youth == 2">
              <div class="tr-title-left">{{ "比赛分组:" }}</div>
              <div class="tr-right">
                <!-- <span class="cx-item" v-for="(item,index) in gameInfo.bow" :key="index">{{item.name}}</span> -->
                <div
                  class="color"
                  v-for="(item, index) in groupList"
                  :key="index"
                  :class="{ active: item.value == form.setgroup }"
                  @click="form.setgroup = item.value"
                >
                  <a href="javascript:;">{{ item.name }}</a>
                </div>
              </div>
            </div>
            <div class="tr-group">
              <div class="tr-title-left">{{ "比赛类型:" }}</div>
              <div class="tr-right">
                <div class="color" v-for="(item, index) in typeList" :key="index" :class="{ active: item.value == selectClass }" @click="setType(item)">
                  <a href="javascript:;">{{ item.name }}</a>
                </div>
              </div>
            </div>

            <div class="tr-foot" v-if="gameInfo.status == 2">
              <div class="btn buy-btn" :class="{ disabled: choosePerson || !selectClass }" v-if="selectClass == 1" @click="nowPay()">{{ "去缴费" }}</div>
              <div class="btn buy-btn" :class="{ disabled: choosePerson || !selectClass }" v-else @click="choosePeople()">{{ "选择参赛人员" }}</div>
            </div>
            <div class="tr-foot">
              <div class="btn buy-btn" :class="{ disabled: true }" v-if="gameInfo.status == 3">{{ "竞赛中" }}</div>
              <div class="btn buy-btn" :class="{ disabled: true }" v-if="gameInfo.status == 4">{{ "报名结束" }}</div>
              <div class="btn buy-btn" :class="{ disabled: true }" v-if="gameInfo.status == 5">{{ "报名未开始" }}</div>
              <div class="btn buy-btn" :class="{ disabled: true }" v-if="gameInfo.status == 6">{{ "比赛未开始" }}</div>
            </div>
          </div>
        </div>

        <div class="c_content">
          <div class="c_content_l">
            <div class="card">
              <div class="card_body">
                <div class="card_tab"><i></i>实时成绩</div>
                <div class="btns">
                  <router-link tag="a" target="_blank" :to="{ name: 'gameRanking', params: { gameId: gameInfo.id } }"
                    ><div class="defaultBtn">排位赛</div></router-link
                  >
                  <router-link tag="a" target="_blank" :to="{ name: 'gameTie', params: { gameId: gameInfo.id } }"
                    ><div class="defaultBtn">淘汰赛</div></router-link
                  >
                </div>
              </div>
            </div>

            <!-- <div class="card">
              <div class="card_body">
                <div class="card_tab"><i></i>比赛动态</div>
                <div class="btn">弓箭比赛积分更新文件</div>
              </div>
            </div> -->

            <div class="card">
              <div class="card_body">
                <div class="card_tab"><i></i>参赛人员</div>
                <div class="person-con">
                  <div class="left">
                    <div class="icon-bg" v-if="allPersonPart.length > 0">
                      <img class="icon" v-for="(item, index) in allPersonPart" :key="index" :src="item.cover ? item.cover : defaultAvatar" />
                    </div>
                    <div class="icon-bg" style="text-align: left" v-else>暂无参赛人员</div>
                  </div>
                  <router-link v-if="allPersonPart.length > 0" tag="a" target="_blank" :to="{ name: 'gameEntry', params: { gameId: gameId } }"
                    ><div class="btn_arrow">查看全部</div></router-link
                  >
                  <!-- <div v-else>暂无参赛人员</div> -->
                </div>
              </div>
            </div>

            <div class="card" v-if="areaPro.arrow_path">
              <div class="card_body">
                <div class="card_tab"><i></i>场馆介绍</div>
                <img v-if="areaPro.scene_graph[0] && areaPro.scene_graph[0].image_path" :src="areaPro.scene_graph[0].image_path" class="pic_bg" alt="" />
                <div class="product-name">{{ areaPro.name }}</div>
                <div class="product-icon">
                  <div class="item" v-show="areaPro.arrow_path">
                    <img class="icon" src="@/assets/images/icon-az.png" mode="" />
                    <div class="text">{{ areaPro.arrow_path }}条箭道</div>
                  </div>
                  <div class="item" v-show="areaPro.distance">
                    <img class="icon" src="@/assets/images/icon-bz.png" mode="" />
                    <div class="text">
                      {{ areaPro.distance }}
                    </div>
                  </div>
                  <div class="item" v-show="areaPro.num">
                    <img class="icon" src="@/assets/images/icon-cz.png" mode="" />
                    <div class="text">{{ areaPro.num }}选手</div>
                  </div>
                </div>
                <div class="line"></div>
                <div class="" v-if="areaPro.content" v-cloak>
                  <div class="img-zxc" v-html="areaPro.content" v-lazy-container="{ selector: 'img' }"></div>
                </div>
                <div class="" v-else>
                  <div class="img-zxc">暂无</div>
                </div>
              </div>
            </div>
          </div>
          <div class="c_content_r">
            <el-collapse v-model="activeName" accordion v-if="noticeList && noticeList.length > 0" @change="changeCollapse($event)">
              <el-collapse-item v-for="(item, index) in noticeList" :key="index" :title="item.title" :name="String(index + 1)">
                <div v-cloak v-if="contentConnet" class="" v-html="contentConnet" v-lazy-container="{ selector: 'img' }"></div>
              </el-collapse-item>
            </el-collapse>
            <!-- <div v-if="contentConnet" class="" v-html="contentConnet" v-lazy-container="{ selector: 'img' }"></div> -->
            <div v-else style="font-size: 14px; color: rgba(49, 44, 44, 1); padding: 20px">暂无通知</div>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in">
      <div class="scrollTop" v-show="toTopShow" @click="scrollToTop">
        <i class="icon iconfont iconfanhuidingbu"></i>
        <p>{{ $t("top") }}</p>
      </div>
    </transition>

    <el-dialog title="提示" :visible.sync="showTips" width="30%" :before-close="handleClose">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column">
        <span>{{ tipsContent }}</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTips = false">取 消</el-button>
        <el-button type="primary" @click="showTips = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择参赛人员" :visible.sync="showPersonList" width="580px" center>
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column">
        <div class="search-b">
          <el-input placeholder="请输入内容" v-model="keyword" class="input-with-select">
            <el-button slot="append" style="color: rgba(231, 68, 47, 1)" @click="search()">搜索</el-button>
          </el-input>
          <div class="" style="padding: 8px"></div>
        </div>

        <el-checkbox-group v-model="checkList" @change="checkboxGroupChange($event)" v-if="allPerson.length > 0" class="game-checkbox-group">
          <div class="item-bg" v-for="(item, index) in allPerson" :key="index">
            <el-checkbox :label="item.name"></el-checkbox>
            <div class="avatar">
              <img v-if="item.cover" :src="item.cover" mode="" />
            </div>
            <div class="name">{{ item.name }}</div>
            <div class="sex">
              {{ item.sex }}
            </div>
            <div class="phone">
              {{ item.mobile }}
            </div>
          </div>
        </el-checkbox-group>
        <div class="no-data" v-if="allPerson.length == 0">暂无数据</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showPersonList = false">取 消</el-button>
        <el-button type="primary" @click="teamToPay()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "gameDetail",
  props: {},
  data() {
    return {
      activeName: "1",
      toTopShow: false,
      gameId: "",
      imgList: [],
      productImgList: [],
      ulLeft: 0,
      isEnd: false,
      gameInfo: {}, //比赛详情
      currentImg: "", //列表选中图片
      loadingShow: false,
      userToken: "",
      loading: false,
      groupList: [
        { name: "甲组", value: 1 },
        { name: "乙组", value: 2 },
        { name: "丙组", value: 3 },
      ],
      typeList: [
        { name: "个人参赛", value: 1 },
        { name: "团队参赛", value: 2 },
      ],
      form: {
        plan_id: "",
        payment_code: "wechatpay",
        bow: 1,
        setgroup: 1,
      },
      showDisBtn: false,
      showManage: false,
      selectClass: 1,
      showTips: false,
      showPersonList: false,
      choosePerson: false,
      allPerson: [],
      user_id: "",
      keyword: "",
      institution_id: "",
      checkList: [],
      allPersonPart: [],
      areaPro: {},
      contentConnet: "",
      tipsContent: "团队报名必须由团队、学校或者团队负责人进行统一报名。",
      noticeList: [],
      institution_id_describeedit: "",
    };
  },

  computed: {
    ulWidth() {
      if (this.gameInfo.album) {
        return this.gameInfo.album.length * 62 + "px";
      }
      return 0 + "px";
    },
  },
  methods: {
    changeCollapse(e) {
      console.log(e);
      let id = this.noticeList[e * 1 - 1].id;
      this.$api
        .getTrendsInfo({
          id: id,
        })
        .then((res) => {
          if (res.status) {
            //把图片的src替换为data-src
            this.contentConnet = res.data.content.replace(/<img src/g, `<img style="max-width: 100%; height:auto;" data-src`);
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    teamToPay() {
      if (this.user_id) {
        this.showPersonList = false;
        this.nowPay();
      } else {
        this.$message({
          message: "请选择参赛人员",
          type: "warning",
        });
      }
    },
    checkboxGroupChange(e) {
      this.user_id = "";
      let arr = [];
      e.forEach((element) => {
        this.allPerson.forEach((person) => {
          if (element == person.name) {
            arr.push(person.user);
          }
        });
      });
      this.user_id = arr.toString();
      // console.log("choose userid==", this.user_id);
    },
    handleClose() {
      this.showTips = false;
    },
    // 补充通知
    getTrendsList() {
      this.$api
        .getTrendsList({
          id: this.gameId,
        })
        .then((res) => {
          if (res.status) {
            if (res.data.list && res.data.list.length > 0) {
              this.noticeList = res.data.list;
              let id = res.data.list[0].id;

              this.$api
                .getTrendsInfo({
                  id: id,
                })
                .then((res) => {
                  if (res.status) {
                    //把图片的src替换为data-src
                    this.contentConnet = res.data.content.replace(/<img src/g, `<img style="max-width: 100%; height:auto;" data-src`);
                  } else {
                    this.$common.errorToShow(res.msg);
                  }
                });
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    // 左下方的参赛人员列表
    gamePerson() {
      this.$api
        .getInstitution({
          id: this.gameId,
        })
        .then((res) => {
          if (res.status) {
            if (res.data && res.data.length > 0) {
              if (res.data[0] && res.data[0].userlist && res.data[0].userlist.length > 5) {
                this.allPersonPart = res.data[0].userlist.splice(0, 5);
              } else {
                this.allPersonPart = res.data[0].userlist;
              }
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },

    setType(e) {
      switch (e.value) {
        case 1:
          this.selectClass = 1;
          // 直接缴费
          break;
        case 2:
          // 选择团队
          this.selectClass = 2;
          // if (this.showDisBtn) {
          //   // 提示加入团队
          //   this.showTips = true;
          // }
          break;
        default:
          break;
      }
    },
    // 缴费
    nowPay() {
      if (this.user_id) {
        this.form.user_id = this.user_id;
      }

      this.$api.gamePay(this.form).then((res) => {
        if (res.status) {
          let order_id = res.data.order_id;
          if (res.data.amount * 1) {
            this.$router.push({
              name: "gamePay",
              params: { order_id: order_id, type: 11, title: this.gameInfo.title, project_id: this.gameId },
            });
          } else {
            this.$message({
              message: "报名成功",
              type: "warning",
            });
          }
        } else {
          this.$message({
            message: "您已报名成功，请勿重复报名",
            type: "warning",
          });
        }
      });
    },
    choosePeople() {
      if (this.choosePerson || !this.selectClass) {
        return false;
      }
      if (this.showDisBtn) {
        this.showTips = true;
      } else {
        this.showPersonList = true;
      }

      // searchClass=1下单  searchClass=2 更换人员
    },
    // 选择参赛人员
    allEnrollPerson(key) {
      this.$api
        .tagselectinstitutionuser({
          institution_id: this.institution_id_describeedit,
          keyword: key,
        })
        .then((res) => {
          if (res.data) {
            this.allPerson = res.data;
          }
        });
    },
    scrollPrev() {
      this.ulLeft = 0;
    },

    scrollNext() {
      let num = this.productImgList.length - 5;
      let left = 54 * num + 24;
      this.ulLeft = -left;
      this.isEnd = true;
    },

    //切换显示图片
    changeShowImg(img) {
      this.currentImg = img;
    },
    returnTo(id) {
      // document.getElementById(id).scrollIntoView({behavior: "smooth"})
      document.getElementById(id).scrollIntoView();
    },

    //比赛详情
    getGameDetail() {
      this.loading = true;
      let data = {
        id: this.gameId,
      };
      let userToken = this.$storage.get("userToken");
      if (userToken) {
        data["token"] = userToken;
      }
      this.loadingShow = true;
      this.$api.getInfo(data).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        if (res.status) {
          this.loadingShow = false;
          let info = res.data;
          this.institution_id = res.data.institution_id;
          this.gameInfo = info;
          this.currentImg = this.gameInfo.banner || "";
          this.productImgList = this.gameInfo.album || [this.gameInfo.banner];
          this.getproduct();
        }
      });
    },
    // user机构id
    manageStatus() {
      this.$api.describeedit({ club: 1 }).then((res) => {
        if (res.status) {
          if (res.data && res.data.info && res.data.info.manage == 1) {
            this.showManage = true;
          } else {
            this.showDisBtn = true;
          }
          this.institution_id_describeedit = res.data.info.id;
          this.allEnrollPerson();
        } else {
          this.showDisBtn = true;
        }
      });
    },
    getproduct() {
      this.$api
        .institutionInfo({
          id: this.institution_id,
        })
        .then((res) => {
          if (res.status) {
            this.areaPro = res.data;

            //把图片的src替换为data-src
            if (this.areaPro.content) {
              // this.areaPro.content = this.areaPro.content.replace(/src/g, "data-src");
              this.areaPro.content = this.areaPro.content.replace(/<img src/g, `<img style="max-width: 100%; height:auto;" data-src`);
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    getAllInfo() {
      this.getGameDetail();
      this.gamePerson();
      this.getTrendsList();
    },
    search() {
      this.allEnrollPerson(this.keyword);
    },
    handleScroll() {
      this.scrollTop = this.scrollTop = window.pageYOffset || document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
  destroyed() {},
  created() {},
  async mounted() {
    this.userToken = localStorage.getItem("userToken");
    let gameId = this.$route.params.gameId;
    this.gameId = gameId;
    this.form.plan_id = this.gameId;
    await this.manageStatus();
    await this.getAllInfo();
    this.$nextTick(function () {
      window.addEventListener("scroll", this.handleScroll);
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.product_related {
  width: 1226px;
  border: 1px solid #eeeeee;
  margin-top: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: normal;
    color: #4c4c4c;
    b {
      display: block;
      font-weight: normal;
      padding-left: 15px;
      color: #4c4c4c;
      height: 40px;
      font-size: 16px;
    }
  }
  ul {
    width: 1198px;
    overflow: hidden;
    margin: 10px 0px;
    li {
      width: 160px;
      overflow: hidden;
      float: left;
      text-align: center;
      margin-left: 26px;
      margin-right: 10px;
      margin-bottom: 10px;
      .img {
        width: 160px;
        height: 160px;
      }
      .related_name {
        height: 36px;
        line-height: 18px;
        overflow: hidden;
        margin-top: 10px;
        font-size: 12px;
        &:hover {
          color: #09f;
        }
      }
      .add-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #e7442f;
        .price {
          font-weight: bold;
        }
        .add-btn {
          font-size: 12px;
          color: #e7442f;
          border: 1px solid currentColor;
          padding: 4px 8px;
          cursor: pointer;
        }
      }
    }
  }
}
.img-zoom-enter-active,
.img-zoom-leave-active {
  width: 100%;
  transition: all 0.2s linear;
}
.img-zoom-enter,
.img-zoom-leave-to {
  width: 0;
  opacity: 0;
}
.scrollTop {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: $theme-color;
  text-align: center;
  color: #fff;
  z-index: 999;
  cursor: pointer;
  .icon {
    display: block;
    margin-top: 12px;
    margin-bottom: 5px;
  }
  p {
    font-size: 12px;
  }
}
.comment {
  display: flex;
  border-bottom: 1px solid $border;
  padding: 15px 0;
  .user {
    display: inline-flex;
    .user-head {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      overflow: hidden;
      img {
        display: block;
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
    }
    .user-name {
      display: inline-block;
      color: #757575;
      font-size: 12px;
      width: 75px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .detail {
    flex: 1;
    .content {
      padding: 10px 0;
    }
    .img-list {
      margin: 10px 0;
      display: inline-flex;
      .img-li {
        width: 52px;
        height: 52px;
        margin-right: 10px;
        margin-bottom: 5px;
        border: 1px solid $border;
        padding: 2px;
        &.active {
          padding: 1px;
          border: 2px solid $theme-color;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .big-img {
      max-width: 300px;
      border: 1px solid $border;
      padding: 2px;
      &.hidden {
        border: none;
        padding: 0;
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
    .time {
      color: #999;
      font-size: 12px;
      margin-top: 10px;
      .addon {
        margin-right: 20px;
      }
    }
  }
}

.wrapper {
  .main {
    padding-top: 14px;
    .t {
      display: flex;
      padding-bottom: 30px;
      .tl {
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        .tl-img-box {
          width: 500px;
          height: 500px;
          border: 1px solid $border;
          margin-bottom: 16px;
          position: relative;
          .play-acution {
            position: absolute;
            left: 10px;
            bottom: 10px;
            width: 40px;
            height: 40px;
            z-index: 9;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .tl-tabs {
          height: 90px;
          position: relative;
          // margin-right: 10px;
          .img-list-box {
            width: 90px;
            height: 90px;
            // margin: 0 auto;
            position: relative;
            overflow: hidden;
            padding-bottom: 4px;
            display: flex;
            ul {
              position: absolute;
              left: 0;
              top: 0;
              height: 90px;
              transition: left 0.15s linear;
              li {
                width: 90px;
                height: 90px;
                // float: left;
                margin-right: 13px;
                border: 1px solid $border;
                padding: 1px;
                box-sizing: border-box;
                &:hover {
                  border: 2px solid $theme-color;
                  padding: 0;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
          .prev {
            position: absolute;
            left: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
          .next {
            position: absolute;
            right: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
        }
      }
      .tr {
        flex: 1;
        position: relative;
        .tr-title {
          font-weight: 700;
          color: rgba(49, 44, 44, 1);
          padding-top: 10px;
          line-height: 28px;
          font-size: 24px;
          margin-bottom: 43px;
        }
        .tr-desc {
          font-size: 14px;
          margin-bottom: 20px;
        }
        .tr-group {
          margin-bottom: 30px;
          position: relative;
          display: flex;
          align-items: center;
          &.underline {
            padding-bottom: 10px;
            border-bottom: 1px solid $border;
          }
          .tr-title-left {
            color: #838383;
            font-size: 14px;
            display: inline-block;
            min-width: 60px;
            padding-right: 10px;
            height: 32px;
            line-height: 32px;
          }
          .tr-right {
            display: inline-block;
            flex: 1;
            .text {
              font-size: 14px;
            }
            .discounts-login {
              font-size: 12px;
              cursor: pointer;
              span {
                color: #e7442f;
              }
            }
            .now-price {
              color: $theme-color;
              text-align: left;
              margin-right: 20px;
              i {
                font-size: 16px;
              }
              .price-num {
                font-size: 22px;
              }
            }
            .old-price {
              color: #666;
              font-size: 12px;
            }
            .cx-item {
              padding: 2px 4px;
              background: $theme-color;
              color: #fff;
              margin-right: 10px;
              font-size: 14px;
              height: 24px;
              line-height: 24px;
            }
            .color,
            .size {
              font-size: 14px;
              border: 1px solid #b8b7bd;
              margin-right: 8px;
              display: inline-block;
              height: 32px;
              width: 100px;
              text-align: center;
              line-height: 32px;
              // margin-bottom: 12px;
              &.active {
                border-color: $theme-color;
                background: $theme-color;
                color: #fff;
              }
              a {
                display: block;
                padding: 0 10px;
              }
              &:hover {
                border: 1px solid $theme-color;
              }
            }
            .weight {
              font-size: 12px;
            }
            .kc {
              color: #878787;
              display: inline-block;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }
      }
    }
    .c_content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .c_content_l {
        width: 400px;
        margin-right: 20px;
        .card {
          padding: 26px 20px 23px;
          margin: 0 0 20px;
          background: #ffffff;
          .card_body {
            .card_tab {
              width: 100%;
              height: 22px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(49, 44, 44, 1);
              line-height: 22px;
              margin-bottom: 27px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              i {
                width: 4px;
                height: 16px;
                display: inline-block;
                background-color: rgba(231, 68, 47, 1);
                margin-right: 8px;
              }
            }
            .person-con {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .left {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              width: 80%;
              height: 60px;

              .icon-bg {
                .icon {
                  width: 60px;
                  height: 60px;
                  display: inline-block;
                  border-radius: 50%;
                  box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
                  border: 2rpx solid white;
                  margin-right: -12px;
                }
              }
            }

            .btn_arrow {
              width: 80px;
              height: 32px;
              background-color: #f2f3f3;
              border-radius: 100px;
              color: #808080;
              font-size: 10px;
              text-align: center;
              line-height: 32px;
            }
            .btn {
              width: 95%;
              height: 52px;
              background-color: rgba(250, 250, 250, 1);
              color: rgba(49, 44, 44, 1);
              font-size: 14px;
              line-height: 52px;
              text-align: left;
              padding-left: 18px;
              img {
                width: 18px;
                height: 18px;
                margin-right: 4px;
              }
            }
            .btns {
              display: flex;
              justify-content: space-between;

              .defaultBtn {
                width: 165px;
                height: 52px;
                background-color: rgba(250, 250, 250, 1);
                color: rgba(49, 44, 44, 1);
                font-size: 14px;
                line-height: 52px;
                text-align: center;
              }
            }
            .pic_bg {
              width: 100%;
              height: 150px;
              margin-bottom: 20px;
            }
            .line {
              width: 100%;
              border: 1px solid rgba(242, 241, 241, 1);
              margin-bottom: 20px;
            }
            .product-name {
              height: 20px;
              font-size: 14px;
              text-align: left;
              line-height: 20px;
              margin-bottom: 20px;
              font-weight: 600;
            }
            .product-icon {
              display: flex;
              justify-content: space-around;
              align-items: center;
              margin-bottom: 20px;

              .item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .icon {
                  width: 26px;
                  height: 26px;
                  display: block;
                  margin-bottom: 9px;
                }
              }
            }

            .img-zxc {
              width: 100%;
              height: auto;
              position: relative;
              margin-bottom: 5px;
              font-size: 14px;
              line-height: 20px;

              img {
                max-width: 100% !important;
                height: auto;
              }
              p {
                width: 100%;

                img {
                  max-width: 100%;
                }
              }
            }
          }
        }
      }
      .c_content_r {
        width: 820px;
        min-height: 200px;
        background: #ffffff;
        padding: 20px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  bottom: 0;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.b {
  padding: 20px 0;
  border-top: 1px solid $border;
  .tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    .tab {
      font-size: 16px;
      padding: 0px 15px;
      cursor: pointer;
      &:not(:last-of-type) {
        border-right: 1px solid $border;
      }
      &.active,
      &:hover {
        color: $theme-color;
      }
    }
  }
  .shop-info-wrap {
    border: 1px solid $border;
    padding: 20px;
    .params-wrap {
      padding: 15px 0;
      border-bottom: 1px solid $border;
      margin-bottom: 20px;
      h3 {
        margin-bottom: 10px;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .params-content {
        padding-left: 20px;
        color: #757575;
        font-size: 12px;
        margin: 10px 0;
      }
    }
    #comment {
      padding: 15px 0;
      h3 {
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .no-comment {
        padding-left: 20px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
.leaderboard {
  float: left;
  width: 21%;
  margin-right: 7px;
  .title {
    background-color: #eee;
    line-height: 40px;
    padding: 0 5px;
  }
  .board {
    border: 1px solid #dee2e9;
    background-color: #fff;
    .item:last-child {
      border: none;
    }
    .item {
      display: flex;
      justify-content: flex-start;
      border-bottom: 1px solid #dee2e9;
      padding: 10px;
      cursor: pointer;
      .number {
        background-color: #333;
        color: #fff;
        width: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
      }
      .img {
        width: 150px;
        // height: 150px;
        object-fit: cover;
        // border: 1px solid #dee2e9;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        width: 63%;
        margin-left: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .name {
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #666;
          font-size: 12px;
          line-height: 18px;
        }
        .price {
          color: #ff7159;
        }
        .sold {
          color: #666;
          font-size: 12px;
          .num {
            color: #ff7159;
          }
        }
      }
    }
  }
}

.color.diable {
  color: #ccc;
  border: 1px solid #ccc;
  cursor: not-allowed !important;
  a {
    cursor: not-allowed !important;
  }
  &:hover {
    border: 1px solid #ccc !important;
  }
}

.integral {
  margin-top: 10px;
  margin-bottom: 14px;
  span {
    color: #ff4444;
    background: rgba(243, 235, 227, 0.5);
    padding: 4px 20px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 10px;
  }
}
</style>

<style lang="scss">
.preview-box {
  img {
    height: 350px;
    object-fit: cover;
  }
}

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  height: 100% !important;
}

.game-checkbox-group {
  .el-checkbox {
    .el-checkbox__label {
      display: none;
    }
  }
}

// 自定义样式
.item-bg {
  width: 520px;
  height: 60px;
  border-radius: 5px;
  background-color: rgba(250, 250, 250, 1);
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 14px;
  color: #6c7a85;
  margin-bottom: 10px;

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    margin: 0 8px 0 15px;
  }

  .name {
    width: 22%;
    color: #05111a;
    word-wrap: break-word;
    margin-right: 8px;
  }

  .sex {
    width: 10%;
  }

  .phone {
    width: 35%;
  }
  .btn {
    width: 13%;
    height: 25px;
    border-radius: 10px;
    background-color: #6c7a85;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.search-b {
  position: relative;
  background-color: rgba(250, 250, 250, 1);
  // width: 710rpx;
  width: 100%;
  height: 42px;
  border-radius: 5px;
  margin-bottom: 10px;

  // &::after {
  // 	position: absolute;
  // 	width: 1px;
  // 	height: 14px;
  // 	right: 55px;
  // 	bottom: 14px;
  // 	z-index: 200;
  // 	content: '';
  // 	background: rgb(181, 188, 193);
  // 	border-radius: 2px;
  // }
}
</style>
